import PocketBase from 'pocketbase';

const pb = new PocketBase('https://theviolentsquirrels.fr/pb');

export default pb;
